import './MouseInvert.css';

const MouseInvert = () => {
  return null;
};

export default MouseInvert;
